export { default } from './ShipmentContentsTable'
